import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { addDays } from 'date-fns';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import Drawer from 'UiKit/drawer';
import { CalendarIcon, CloseIcon } from 'Asset/icon';
import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';

import styles from './styles.module.css';

const FilterDateRangePickerMobile = ({ startDate: propStartDate, endDate: propEndDate, dateOffset, onChange, minDate, maxDate }) => {
  const { t } = useTranslation('host-schedule');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [startDate, setStartDate] = useState(propStartDate);
  const [endDate, setEndDate] = useState(propEndDate);

  const handleDateChange = (dates) => {
    const [start, end] = dates;

    setStartDate(start);

    if (dateOffset) setEndDate(addDays(start, dateOffset - 1));
    else setEndDate(end);
  };

  const handleApply = () => {
    if (startDate && endDate) onChange({ startDate, endDate });
    else if (startDate && dateOffset) onChange({ startDate, endDate: addDays(startDate, dateOffset) });
    else startDate && onChange({ startDate, endDate: startDate });

    onClose();
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const selectedStartDate = startDate ? moment(startDate)?.format('DD MMM YYYY') : '';
  const selectedEndDate = endDate ? moment(endDate)?.format('DD MMM YYYY') : '';

  useEffect(() => {
    if (isOpen) {
      setStartDate(propStartDate);
      setEndDate(propEndDate);
    }

    /* eslint-disable */
  }, [isOpen]);

  return (
    <Box className={styles['filter__container']}>
      <Flex className={styles['trigger__button']} onClick={onOpen}>
        <CalendarIcon size="22px" />
        <TextSemiBold>{t('filter.date_picker.date')}</TextSemiBold>
      </Flex>

      <Drawer isOpen={isOpen} onClose={onClose}>
        <Flex className={styles['drawer-head__section']}>
          <TextBold className={styles['title__text']}>{t('filter.date_picker.date')}</TextBold>
          <CloseIcon size="16px" onClick={onClose} />
        </Flex>

        <Flex className={styles['drawer-selected__section']}>
          <Box className={styles['selected__item']}>
            <TextBold className={styles['selected__label']}>{t('filter.date_picker.start_date')}</TextBold>
            <TextRegular className={styles['selected__text']} color={selectedStartDate ? 'var(--color-semantic-text)' : 'var(--color-neutral40)'}>
              {selectedStartDate || t('filter.date_picker.date_placeholder')}
            </TextRegular>
          </Box>

          <Box className={styles['selected__item']}>
            <TextBold className={styles['selected__label']}>{t('filter.date_picker.end_date')}</TextBold>
            <TextRegular className={styles['selected__text']} color={selectedEndDate ? 'var(--color-semantic-text)' : 'var(--color-neutral40)'}>
              {selectedEndDate || t('filter.date_picker.date_placeholder')}
            </TextRegular>
          </Box>
        </Flex>

        <Box className={styles['drawer-calendar__section']}>
          <DatePicker
            formatWeekDay={(name) => name.charAt(0)}
            selectsRange
            openToDate={startDate}
            minDate={minDate}
            maxDate={maxDate}
            inline
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
            onMonthChange={() => {}} // Required to prevent console warning
          />
        </Box>

        <Flex className={styles['drawer-footer__section']}>
          <ButtonOutline className={styles['clear__button']} onClick={handleClear} borderWidth={'1.5px'}>
            {t('common:clear')}
          </ButtonOutline>
          <ButtonSolid className={styles['apply__button']} onClick={handleApply}>
            {t('common:apply')}
          </ButtonSolid>
        </Flex>
      </Drawer>
    </Box>
  );
};

export default FilterDateRangePickerMobile;
